import adminTemplate from './admin.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider.state('admin', {
    url: '/admin',
    template: adminTemplate,
    controller: 'AdminController',
    controllerAs: 'admin',
    authenticate: 'admin'
  });
}];
